import type { SoundCatalog, SoundCueDefinition } from '@sorrem/shared';

/** A cue a command asked for, as the catalog defines it. */
export interface ResolvedCue {
    readonly id: string;
    readonly definition: SoundCueDefinition;
}

/** The first of `cues` the catalog defines, or null when it defines none of them (or has no files for it). */
export function resolveCue(catalog: SoundCatalog, cues: readonly string[]): ResolvedCue | null {
    for (const id of cues) {
        const definition = catalog.cues[id];
        if (definition !== undefined && definition.files.length > 0) {
            return { id, definition };
        }
    }
    return null;
}

/** Every file the catalog plays, once each: what the page preloads. */
export function listCatalogFiles(catalog: SoundCatalog): string[] {
    return [...new Set(Object.values(catalog.cues).flatMap((cue) => cue.files))];
}

/** One of a cue's files and its playback rate, picked from `random` (0..1) draws. */
export function pickCueVariant(definition: SoundCueDefinition, random: () => number): { file: string; rate: number } {
    const file = definition.files[Math.min(definition.files.length - 1, Math.floor(random() * definition.files.length))] ?? '';
    const [low, high] = definition.pitch ?? [1, 1];
    return { file, rate: low + (high - low) * random() };
}
